var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{'pp-ui-button': _vm.applyStyles, 'pp-ui-button-options': _vm.applyStyles},on:{"click":function($event){_vm.player.showOptions = true}}},[_vm._t("default",function(){return [_c('Icon')]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }